var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Remove first carouse slide on mobile
            if ($(window).width() < 992) {
                $('.project-carousel').each((carousel) => {
                    carousel.find('.carousel-item').first().remove();
                    carousel.find('.carousel-item').first().addClass('active');
                });
            }
            $('.btn-open-carousel').on('click', (event, button) => {
                const isInIndex = button.parents('.index').length > 0;
                console.log(isInIndex);
                if ($(window).width() >= 992 && isInIndex)
                    return;
                event.preventDefault();
                this.currentProject = isInIndex ? $(button.attr('href')) : button.parents('.project');
                this.currentProject.find('.project-carousel').removeClass('d-none').addClass('d-flex is-opened');
                $('.component-menu').removeClass('z-3').addClass('z-4');
            });
            $('.btn-close-project').on('click', (event, button) => {
                $('.project-carousel, .project-infos-mobile').addClass('d-none').removeClass('d-flex is-opened');
                $('.component-menu').removeClass('z-4').addClass('z-3');
            });
            $('.btn-open-project-info').on('click', (event, button) => {
                this.currentProject.find('.project-infos-mobile').removeClass('d-none');
            });
            $('.btn-open-project-carousel').on('click', (event, button) => {
                $('.project-infos-mobile').addClass('d-none');
            });
            this.success();
        });
    }
}
